import { Action as ReduxAction } from 'redux';
import { Messages } from '../../../../codegen/Localize';
import { FeatureFlags } from '../../../../ts/FeatureFlags';
import { IContentInfo } from '../../../../ts/models/IContentInfo';
import { IDeleteAction as IDeleteActionApi } from '../../../../ts/ServerApi/types/actionNames';
import { deleteCollectionAction } from '../../../actions/spaces/DeleteCollectionAction';
import { CompositeSessionInfoSelectors } from '../../../selectors/SessionInfoSelectors';
import { AppState } from '../../../state/AppState';
import { EntityActionNames, IEntityAction } from './IEntityAction';

export const DeleteCollectionAction: IEntityAction<IContentInfo, IDeleteActionApi> = {
  name: EntityActionNames.DeleteCollection,
  translateName: Messages.delete_action,
  isVisible: () => {
    return FeatureFlags.collectionsEnabled;
  },
  isClickable: (_availableActions: {}, targetItems: IContentInfo[], state: AppState) => {
    if(targetItems.length !== 1) return false;

    const item = targetItems[0];
    const isAdminOrOwner = CompositeSessionInfoSelectors.currentUserIsAdminOrOwnerSelector(item.owner)(state);
    return isAdminOrOwner;
  },
  createReduxAction: (targetItems: IContentInfo[]): ReduxAction => {
    return deleteCollectionAction(targetItems[0]);
  },
};

